var SKIT_APP_HELPER = (function (helper) {

    var playlistInstances = [];
    var playlistIndex = 0;
    var playlistState = 'STOP';
    var API_CLIENT_ID = 'e20adb7470f9c3664673be96de79a8d3';//SKIT

    var yt_videos_buffer = [];

    function postAjaxData(url, formdata, succeseCallBack, btnElement, likeOrNot) {

        $.ajax({
            url: url,
            type: 'POST',
            processData: false,
            contentType: false,
            data: formdata,
            success: function( data, textStatus, jQxhr ){
                succeseCallBack( btnElement, data, likeOrNot);
            },
            error: function( jqXhr, textStatus, errorThrown ){
                console.log( errorThrown );
            }
        });
    }

    function postAjaxData2(url, formdata, succeseCallBack) {

        $.ajax({
            url: url,
            type: 'POST',
            processData: false,
            contentType: false,
            data: formdata,
            success: function( data){
                succeseCallBack(data);
            },
            error: function(e ){
                console.log(JSON.stringify(e));
            }
        });
    }

    function getAjaxData(url, succeseCallBack) {
        $.ajax({
            type: 'GET',
            url: url,
            contentType: "application/json",
            dataType: 'jsonp',
            success: function (json) {
                succeseCallBack(json);
            },
            error: function (e) {
                console.log(JSON.stringify(e));
            }
        });
    };

    function isDev() {
      return (window.location.href.indexOf('dev.rtvslo.si') > -1) ? true : false;
    }

    function isMobile() {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
            isMobile = true
        }
        return isMobile;
    }


    /**
     * This modifies DOMs
     */
    function riddleInitDOM() {
        var riddleCheck = $('[data-type="rtv-riddle"]');
        if (riddleCheck) {
            riddleCheck.each(function (i, value) {
                var dataRidId = $(value).attr('data-rid-id');
                var dataFg = $(value).attr('data-fg');
                var dataBg = $(value).attr('data-bg');
                var riddleStyle = $(value).attr('data-riddle-style');
                var riddleIframeStyle = $(value).attr('data-riddle-iframe-style');
                var riddleIframeSrc = $(value).attr('data-riddle-iframe-src');
                var riddleIframeTitle = $(value).attr('data-riddle-iframe-title');
                var riddleIframeContent = $(value).attr('data-riddle-iframe-content');
                var riddleTemplate = '<div class="riddle_target" data-rid-id="' + dataRidId + '" data-fg="' + dataFg + '" data-bg="' + dataBg + '" style="' + riddleStyle + '" data-auto-scroll="false" data-auto-scroll-offset="0"><script src="https://www.riddle.com/files/js/embed.js"></script><link href="https://www.riddle.com/files/css/embed.css" rel="stylesheet"><iframe style="' + riddleIframeStyle + '" src="' + riddleIframeSrc + '" title="' + riddleIframeTitle + '">' + riddleIframeContent + '</iframe></div>';
                $(value).replaceWith(riddleTemplate);
            })
        }

        var riddleCheck = $('[data-type="rtv-riddle-2"]');
        if (riddleCheck.length > 0) {
            riddleCheck.each(function (i, value) {
                var dataRidId = $(value).attr('data-rid-id');
                var dataFg = $(value).attr('data-fg');
                var dataBg = $(value).attr('data-bg');
                var riddleStyle = $(value).attr('data-riddle-style');
                var riddleIframeSrc = $(value).attr('data-riddle-iframe-src');
                var riddleIframeContent = $(value).attr('data-riddle-iframe-content');
                var riddleTemplate = '<div class="riddle2-wrapper" data-rid-id="' + dataRidId + '" data-fg="' + dataFg + '" data-bg="' + dataBg + '" style="' + riddleStyle + '" data-auto-scroll="false" data-is-fixed-height-enabled="false"><script src="https://www.riddle.com/embed/build-embedjs/embedV2.js"></script><iframe src="' + riddleIframeSrc + '" allow="autoplay" referrerpolicy="strict-origin">' + riddleIframeContent + '</iframe></div>';
                $(value).replaceWith(riddleTemplate);
            })
        }
    }
    
    function swapGalleryPositionDOM() {
        var swapGallery = $('[data-type="rtv-gallery-hook"]');
        if (swapGallery) {
            var $galery = $('#gallery-grid-images');
            $(swapGallery).replaceWith($galery);
        }
    }


    function infogramInitDOM() {
        var infogramCheck = $('[data-type="rtv-infogram"]');
        if (infogramCheck) {
            infogramCheck.each(function(i, value) {
                var dataId = $(value).attr('data-id');
                var dataTitle = $(value).attr('data-title');
                var dataSrcEnd = $(value).attr('data-src-end');
                var infogramTemplate = '<script id="' + dataId + '" title="' + dataTitle + '" src="https://e.infogram.com/js/dist/embed.js?' + dataSrcEnd + '" type="text/javascript"></script>';
                $(value).replaceWith(infogramTemplate);
            })

        }
    }

    function tableInArticle(){
        var table = $('[data-type="rtv-frame"]');
        if (table) {
            
                table.each(function(i, value) {
                    
                    var classNames =  $(value).attr('class');
                    var title = $(value).find('th').html();
                    if(typeof title === 'undefined') {
                        title = '';
                    }
                    var content = $(value).find('td').html();

                    var template = '<figure class="' + classNames + '"><h5 class="figure-title center">' + title + '</h5><div class="custom-text-box">' + content + '</div></figure>';
                    $(value).replaceWith(template);

                })
            
        }
       
    }
    function videoInArticle(){
        $("figure").each(function(s, value) {
        
            var recordingData = $(this).data();
            //console.log("videoInArticle -> recordingData", recordingData);
           
            if(recordingData.id && recordingData.type && (recordingData.type === "4dvideo" || recordingData.type === "4daudio" || recordingData.type === "4daudio-podcast")){
                var el = $(this).find(">img:first-child");
                if(el.length === 0){
                  el = $('<div/>');
                  $(this).prepend(el);
                }
                
                el.wrapAll('<div class="embed-responsive embed-responsive-16by9"><div class="embed-responsive-item"></div></div>');
                recordingData.recording = recordingData.id;
                videoInView(el, recordingData);
            }
            if(recordingData.channel && recordingData.type && (recordingData.type === "4dvideo" || recordingData.type === "4daudio")){
              var el = $(this).find(">img:first-child");
              if(el.length === 0){
                el = $('<div/>');
                $(this).prepend(el);
              }
              console.log(this);
              el.wrapAll('<div class="embed-responsive embed-responsive-16by9"><div class="embed-responsive-item"></div></div>');
              videoInView(el, recordingData);
            }
            if(recordingData.id && recordingData.type && recordingData.type === "image") {
                 $(this).addClass('photoswipe');
                var el = $(this).find(">:first-child");
                var href = el.attr('src');
                el.wrap('<a href="' + href + '" data-large="' + href + '" target="_blank"></a>');  
            }

            var news = recordingData;
  
               
            if(news.id && news.url && news.type && news.type === "related-news"){
              
                var el = $(this);
                //console.log("🚀 ~ file: helper.js ~ line 117 ~ $ ~ el", el)

                var url = $(value).attr('data-url');
                var type = $(value).attr('data-type');
                var classValue = $(value).attr('class');
                var img = $(value).find('img');
                var imgSrc = $(img).attr('src');
                var figcaption = $($(value).find('figcaption')).html();

                const newFigure = document.createElement("figure"); 
                $(newFigure).addClass(classValue)
                const div = document.createElement("div"); 
                $(div).addClass('exposed-article');

                const aImg = document.createElement("a");
                $(aImg).addClass('image-link image-heading image-container container-16-9');
                $(aImg).attr('href', '/n/'+url)
                $(aImg).attr('data-large', imgSrc)

                const newImg = document.createElement("img");
                $(newImg).addClass('image-original loaded');
                $(newImg).attr('src', imgSrc)

                
                const aTitle = document.createElement("a");
                $(aTitle).addClass('article-title');
                $(aTitle).attr('href', '/n/'+url)
                $(aTitle).attr('data-large', imgSrc)
                $(aTitle).html(figcaption)

                aImg.append(newImg)
                div.append(aImg)
                div.append(aTitle)
                newFigure.append(div);
                el.replaceWith(newFigure);


              
            }
            

        });

        if(photoswipeInit) {
            photoswipeInit(); 
        }
    }

    function videoInView(element, recordingData) {
        
        var recordingData = recordingData;

        if (typeof recordingData.options === 'undefined') {
            recordingData.options = {};
        }

        recordingData.options["client"] = API_CLIENT_ID;
        recordingData.options["scale"] === "true";
        recordingData.options["autostart"] = "false";
        recordingData.options["mute"] = 0;

        recordingData.options["width"] = "100%";
        recordingData.options["height"] = "400px";
        recordingData.options["disableAds"] = "true"; 
        //console.log('recordingData',recordingData);
        //console.log(recordingData);

        try {

            if (recordingData.recording) {

              // VOD player
              $(element).attr('id', "rtv4dplayer" + recordingData.recording);

              if (recordingData.recording) {
                  $(element).playVod(recordingData.recording, recordingData.options);
              }
            } else if (recordingData.channel) {

              // Live player
              $(element).attr('id', "rtv4dplayer" + recordingData.channel.replace('.', '_'));

              if (recordingData.channel) {
                  $(element).playLive(recordingData.channel, recordingData.options);
              }
            }

        } catch (e) {
            console.log(e);
        }
 
    }

    function pauseAllVideos(){
      
        var videos = document.getElementsByTagName('video');
        if(videos) {
            var videos = Array.prototype.slice.call(videos);
            videos.map(function(itm) {
                jwplayer(itm.parentNode.parentNode.parentNode.id).pause(true);
            })
        }   

        yt_videos_buffer.map(function(video) {
            if(video && video.stopVideo) {
                video.stopVideo();
            }
        })
        
       
    }

    function playVod(rec_id) {

        pauseAllVideos();
        //console.log('Playback just started for: '+rec_id);   
        $('#player-' + rec_id).playVod(rec_id, {client: API_CLIENT_ID, autostart:'true', width:'100%', height:'300px', disableAds:"true" });
    }

    function playLive(station_id) {
      pauseAllVideos();

      $('#player-' + station_id.replace('.', '_')).playLive(station_id, {client: API_CLIENT_ID, autostart:'true', width:'100%', height:'300px', disableAds:"true" });
    }

    function playYT(id) {

        pauseAllVideos();

        if(!YT.Player)return;

        let width = $('#ytplayer_list_' + id).width();
        let height = width * (9/16);
        //console.log("🚀 ~ file: helper.js ~ line 229 ~ playYT ~ height", height)
        var player = new YT.Player('ytplayer_list_' + id, {
                    height: height,
                    playerVars: { 'autoplay': 1 },
                    width: '100%',
                    videoId: id
        });

        yt_videos_buffer.push(player);
     
    }

    function initVideo() {

        return;

        var targetElement = document.querySelectorAll('.player');
        let options = {
            root: null, // relative to document viewport 
            rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
            threshold: 1.0 // visible amount of item shown in relation to root
        };
        var observer = new IntersectionObserver(onChange, options);

        //observer.observe(targetElement);

        targetElement.forEach(player => observer.observe(player));

        function onChange(entries) {
            //console.log("entries", entries)
            entries.forEach(function (entry) {
                if (entry.intersectionRatio > 0) {
                   
                    var recordingData = $(entry.target).data();
                    entry.target.classList.remove('player');
                    var el = $(entry.target).find("a");
                    //console.log("recordingData", recordingData)
                    videoInView(el, recordingData)
                    //entry.target.classList.remove('player');
                    observer.unobserve(entry.target);
                }
            });
        }

        return;


    }

    function featuredRotatorInit(element) {
      if (Swiper) {
        new Swiper (element, {
          loop: true,
          preloadImages: false,
          centeredSlides: true,
          slidesPerView: 'auto',
          autoplay: {
            pauseOnMouseEnter: true
          },
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            init: function () {
              this.el.classList.add('loaded');
            }
          }
        })
      }
    }

    

    function socialInit(){
        //return;
        var instagramJS = '//instagram.com/static/bundles/es6/EmbedSDK.js/bf4a12bd69f3.js';
       
        var checkInstagram = $('.instagram-media').length;
        if (checkInstagram > 0 && typeof window.instgrm === 'undefined') {
            $.getScript(instagramJS);
        }

        var twitterJS = '//platform.twitter.com/widgets.js';
        var checkTwitter = $('.twitter-tweet').length;
        if(checkTwitter > 0){
            $.getScript(twitterJS);
        }

        var checkFB = $('.fb-post').length;
        var checkFBVideo = $('.fb-video').length;
        
        if(checkFB > 0 || checkFBVideo > 0){
            window.fbAsyncInit = function() {
                FB.init({
                  xfbml      : true,
                  version    : 'v3.2'
                });
                }; 
            (function(d, s, id){
                  var js, fjs = d.getElementsByTagName(s)[0];
                  if (d.getElementById(id)) {return;}
                  js = d.createElement(s); js.id = id;
                  js.src = "https://connect.facebook.net/en_US/sdk.js";
                  fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }

        var checkYT = $('figure').length;
        if(checkYT > 0){
            //return;
            //console.log("socialInit -> checkYT", checkYT)
            var figures = $('figure');
            var yt_videos = [];
           
            figures.each(function(itm){
                //console.log("socialInit -> itm", figures[itm])
                var type = $(figures[itm]).data('type');
                if(type === 'youtube'){
                    var id = $(figures[itm]).data('id');
                    var img = $(figures[itm]).find('img');
                    $div = $('<div/>');
                    $div.addClass('embed-responsive');
                    $div.addClass('container-16-9')

                   
                    img.replaceWith($div);

                    $divVideo = $('<div/>');
                    $divVideo.attr('id', 'ytplayer_' + id);
                    $div.append($divVideo);
                    //$(figures[itm]).addClass('embed-responsive');
                    //$(figures[itm]).addClass('container-16-9');
                    //$(figures[itm]).attr('id', 'ytplayer' + id);
                    yt_videos.push(id);
                }
                //console.log("socialInit -> type", type)
                
            })

            yt_videos.map(function(id){
                if(!YT.Player)return;

                var player = new YT.Player('ytplayer_' + id, {
                    height: '360',
                    width: '100%',
                    videoId: id
                });

                yt_videos_buffer.push(player);

                $('#ytplayer_' + id).addClass('embed-resonsive-item')
                
            })

            //console.log("socialInit -> yt_videos", yt_videos)
            //$.getScript(twitterJS);
        }

        var tiktokEmbed = $('[data-type="rtv-tiktok"]');
        if (tiktokEmbed) {
            tiktokEmbed.each(function(i, value) {
                var dataVideoId = $(value).attr('data-video-id');
                var url = $($(value).html()).attr('href');
                var title = $($(value).html()).html();
                var tiktokTemplate =  '<blockquote class="tiktok-embed" cite="'+url+'" data-video-id="'+dataVideoId+'" <section><p>'+title+'</p> <a target="_blank" href="'+url+'"></a> </section> </blockquote>';
                $(value).replaceWith(tiktokTemplate);
            })
            $.getScript('https://www.tiktok.com/embed.js');
        }



        
    }

    var sectionsList = [];
    function readSectionsList() {
        return sectionsList;
    }

    function createSectionTree(sectionId) {
        var apiURL = 'https://api.rtvslo.si';
        if (isDev() === true) {
            apiURL = 'https://api.dev.rtvslo.si';
        }

        const sectionPromise = new Promise((resolve, reject) => {    
            var apiCall = apiURL + '/news/getSection/?client_id=' + API_CLIENT_ID + '&id=' + sectionId;
            getAjaxData(apiCall, function (section) {
                sectionsList.push(section.response);
                resolve();
            });
        });
        sectionPromise.then(function() {
            lastSection = sectionsList[sectionsList.length - 1];
            if (lastSection !== undefined && lastSection.self_id > 0) {
                createSectionTree(lastSection.self_id);
            } else {
                sectionsList.reverse();
            }
        });
    }

    function flushLocalStorage(keyContainingWord) {
        // We loop backward because modifying the localStorage (by removing items) while iterating forward can mess up the index order and potentially skip keys.
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key.includes(keyContainingWord)) {
            localStorage.removeItem(key);
            }
        }
    }

    return {
        flushLocalStorage:flushLocalStorage,
        isMobile:isMobile,
        isDev:isDev,
        getAjaxData:getAjaxData,
        riddleInitDOM:riddleInitDOM,
        initVideo:initVideo,
        videoInArticle:videoInArticle,
        tableInArticle:tableInArticle,
        pauseAllVideos:pauseAllVideos,
        playVod:playVod,
        playLive:playLive,
        postAjaxData:postAjaxData,
        postAjaxData2:postAjaxData2,
        socialInit:socialInit,
        infogramInitDOM:infogramInitDOM,
        swapGalleryPositionDOM:swapGalleryPositionDOM,
        playYT:playYT,
        featuredRotatorInit:featuredRotatorInit,
        createSectionTree:createSectionTree,
        readSectionsList:readSectionsList
    }

})();